import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';

interface UsePatientPortalMasonryPropsParams {
  nodeId: string;
  queryParams?: Record<string, string | undefined>;
}

export const usePatientPortalMasonryProps = ({
  nodeId,
  queryParams,
}: UsePatientPortalMasonryPropsParams) => {
  const { systemId } = usePatientPortalContext();
  return {
    rootNodeId: nodeId,
    initialQueryParams: {
      systemId,
      ...queryParams,
    },
  };
};
